/**
 * 
 * Right.js
 * 
 */

import React, { Component } from 'react'
import { Container, Row, Col } from 'react-bootstrap';

 
 export default class Right extends Component {

    static displayName = Right.name;

     render() {


         return (

             <Container style={{ backgroundColor: '', width: '165%' }}>
                 
                 <Row xl={8}>

                     <Col>
                        
                        <p>
                            <font size="5" color="#156fa1" style={{}}>110+ Million People</font>
                        </p>

                        <p style={{ textAlign: 'left' }}>
                            Ethiopia has the second biggest population in Africa following Nigeria
                        </p>

                     </Col>

                     <Col>

                        <p>
                            <font size="5" color="#156fa1">Growing Middle Class</font>
                        </p>

                        <p style={{ textAlign: 'left' }}>
                            2nd Fastest growing economy in the world, with a rapidly increasing middle class
                        </p>

                     </Col>

                 </Row>

                 <Row>

                     <Col>

                        <p>
                            <font size="5" color="#156fa1">75% Unbanked</font>
                        </p>

                        <p style={{ textAlign: 'left' }}>
                            Majority of the population is unbanked and lacks basic financial services. 
                        </p>

                     </Col>

                     <Col>

                        <p>
                        <font size="5" color="#156fa1">No Int. Banks</font>
                        </p>

                        <p style={{ textAlign: 'left' }}>
                            Ethiopia currently doesn't have any international banks which limits financial access
                        </p>

                     </Col>

                 </Row>

                 <Row>

                     <Col>

                        <p>
                            <font size="5" color="#156fa1">No Online Payment</font>
                        </p>

                        <p style={{ textAlign: 'left' }}>
                            No company has been able to facilitate credit/debit card payment online
                        </p>

                     </Col>

                     <Col>

                        <p>
                            <font size="5" color="#156fa1">Policy change</font>
                        </p>

                        <p style={{ textAlign: 'left' }}>
                            Prior online payment solutions were reserved banks and MFIs. It is now open to private sector.
                        </p>

                     </Col>

                 </Row>

             </Container>
             
         );


     }


 }

